module.exports = __webpack_public_path__ + "static/media/plan1.58ab906e.jpg";